import { type SettlementCreditReceive, TransactionType } from '@shared/graphql'

import { SettlementAdvanceReceiveDetail } from '../SettlementAdvanceReceiveDetail/SettlementAdvanceReceiveDetail'
import { SettlementAdvanceRefundDetail } from '../SettlementAdvanceRefundDetail/SettlementAdvanceRefundDetail'
import { SettlementAdvanceRepayDetail } from '../SettlementAdvanceRepayDetail/SettlementAdvanceRepayDetail'

import type { ApolloError } from '@apollo/client'

const REFUND_TRANSACTION_TYPES = new Set([
  TransactionType.settlement_credit_overrepayment_refund,
  TransactionType.settlement_credit_overrepayment_refund_transfer,
])
const REPAY_TRANSACTION_TYPES = new Set([
  TransactionType.credit_crypto_repayment,
  TransactionType.credit_crypto_repayment_receive,
])

export interface SettlementAdvanceDetailProps {
  /**
   * The transaction we want to render.
   */
  transaction?: SettlementCreditReceive
  /**
   * Error from fetching transaction details.
   */
  error?: ApolloError
}

export const SettlementAdvanceDetail: React.FC<
  SettlementAdvanceDetailProps
> = ({ transaction, error }) => {
  const type = transaction?.payment.type
  const isRefundType = type != null ? REFUND_TRANSACTION_TYPES.has(type) : false
  const isRepayType = type != null ? REPAY_TRANSACTION_TYPES.has(type) : false

  if (isRefundType) {
    return (
      <SettlementAdvanceRefundDetail error={error} transaction={transaction} />
    )
  } else if (isRepayType) {
    return (
      <SettlementAdvanceRepayDetail error={error} transaction={transaction} />
    )
  }

  return (
    <SettlementAdvanceReceiveDetail error={error} transaction={transaction} />
  )
}
